module.exports = __webpack_public_path__ + "cc20ca6ff5aecd6a50053171c7fac18a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/bunny-ears-s.png
// module id = 2164
// module chunks = 0